import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'medpace-delete-request-modal',
    standalone: false,
    templateUrl: './delete-request-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./delete-patient-modal.component.scss'],
})
export class MedpaceDeleteRequestModalComponent {
    constructor(public dialogRef: MatDialogRef<MedpaceDeleteRequestModalComponent>) {}

    closeDialog(): void {
        this.dialogRef.close();
    }

    deleteConfirm(): void {
        this.dialogRef.close(true);
    }
}
